import script from "./UserSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSelect.vue?vue&type=script&setup=true&lang=ts"

import "./UserSelect.vue?vue&type=style&index=0&id=d6b6f930&scoped=true&lang=css"

import exportComponent from "/builds/pirago/gon/gon-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6b6f930"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QItemLabel,QChip,QIcon});
